import {  sendApi } from ".";
import { T_Code } from "../model/codeModel";
import { T_File } from "../model/fileModel";

async function codeList(data?: any) {

    const response = await sendApi({
      method: "post",
      url: "/code/list",
      data: {
        ...data,
      },
    });

    return response;
  }

async function codeCreate(data1?:T_Code){

  const response = await sendApi({
    method: "post",
    url: "/code/insert",
    data: {
      ...data1,
    },
  });

  return response;
}  
async function codeEdit(data1?:T_Code){

  const response = await sendApi({
    method: "post",
    url: "/code/update",
    data: {
      ...data1,
    },
  });

  return response;
}  
async function codeDelete(data1?:T_Code){

  
  const response = await sendApi({
    method: "post",
    url: "/code/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  




const error = {
    codeList,
    codeCreate,
    codeEdit,
    codeDelete,
  };
  export default error;

